import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Initial state
const initialState = {
  articles: [],
  categories: [],
  faqs: [],
  currentArticle: null,   
  loading: {
    article: false,
    global: false
  },
  error: null
};


// Async thunk for fetching data
export const fetchSupportData = createAsyncThunk(
  'support/fetchSupportData',
  async () => {
    const [ categories, filteredFaqs, filteredArticles] = await Promise.all([
    
      axios.get('/api/support/categories'),
      axios.get('/api/support/faqs'),
      axios.get('/api/support/filteredArticles')
    ]);
    return {
      categories: categories.data,
      filteredFaqs: filteredFaqs.data.filteredFaqs,
      filteredArticles: filteredArticles.data.filteredArticles
    };
  }
);

 
 

const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupportData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupportData.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload.categories;
        state.filteredFaqs = action.payload.filteredFaqs;
        state.filteredArticles = action.payload.filteredArticles
      })
      .addCase(fetchSupportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  }
});

export const { clearCurrentArticle } = supportSlice.actions;
export default supportSlice.reducer;